<template>
  <div>
    <div class="bg-white rounded border-0 shadow-sm">
    <div class="d-flex align-items-end pt-3 pl-3 pr-3 mb-3">
      <div class="d-flex flex-column">
        <h4 class="mb-0">Slot Usage</h4>
      </div>
      <ButtonGroup>
        <b-button :class="{'active' : view === 'preview'}" @click="view = 'preview'">Preview</b-button>
        <b-button :class="{'active' : view === 'code'}"  @click="view = 'code'">Code</b-button>
      </ButtonGroup>
    </div>
 
    <CodePreviewViewer :viewMode="view" :codeSample="require('./multiselect_slot.js').default">
      <template v-slot:preview>
        <div class="bg-white rounded shadow-sm p-3 w-100">
          <MultiSelect label="No Options">
            <template v-slot:no-options>Sorry mate, no options available</template>
          </MultiSelect>
         
          <br><br>
 
          <MultiSelect v-model="optionSelected" :value="optionSelected" :options="options" label="Option Slot">
            <template v-slot:option="data">
              <div>
                <b>{{data.item.text}}</b>
                <p class="text-gray-400">{{data.item.desc}}</p>
              </div>
            </template>
          </MultiSelect>
 
          <br><br>
 
          <MultiSelect v-model="inputSelected" :value="inputSelected" :options="nestedOptions" label="Input Slot">
            <template v-slot:input="data">
              <div class="d-flex align-items-center">
                <img :src="data.item.img" width="24" class="mr-2" style="border-radius: 50em;">
                <p>{{data.item.name}}</p>
              </div>
            </template>
 
            <template v-slot:option="data">
              <div>
                <b>{{data.item.name}}</b>
                <p class="text-gray-400">{{data.item.position}}</p>
              </div>
            </template>
          </MultiSelect>
        </div>
      </template>
    </CodePreviewViewer>
    </div>
  </div>
</template>
 
<script>
import MultiSelect from '@/components/export/MultiSelect/MultiSelect'
import ButtonGroup from '@/components/export/ButtonGroup/ButtonGroup'
import CodePreviewViewer from '@/components/local/CodePreviewViewer'
 
export default {
  components: { ButtonGroup, CodePreviewViewer, MultiSelect },
  data () {
    return {
      view: 'preview',
      optionSelected: null,
      inputSelected: null,
      options: [
        { text: 'John Doe', desc: 'Unknown Person', value: '1' },
        { text: 'Kib Beck', desc: 'Versatile Person', value: '2' },
      ],
      nestedOptions: [
        {
          name: 'Kobe Forrosuelo',
          position: 'Front End Developer',
          img: 'https://faces-img.xcdn.link/image-lorem-face-5477.jpg',
          value: '1'
        },
        {
          name: 'Reyven Biloy',
          position: 'Design Director',
          img: 'https://faces-img.xcdn.link/image-lorem-face-3575.jpg',
          value: '2'
        }
      ]
    }
  }
}
</script>
 
<style>
 
</style>